import { FormError } from "model/index";

export class BadRequestError extends Error {
  constructor(readonly errors: ReadonlyArray<FormError>) {
    super("Bad Request");
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
